import api from './api';
import { Aviso, AvisoComDetalhes } from '../types/avisos';

export const avisoService = {
  /**
   * Obtém todos os avisos relevantes para o usuário atual
   */
  obterAvisos: async () => {
    try {
      const response = await api.get('/avisos');
      return response.data;
    } catch (error) {
      console.error('Erro ao obter avisos:', error);
      throw error;
    }
  },

  /**
   * Obtém um aviso específico pelo ID
   */
  obterAvisoPorId: async (id: string) => {
    try {
      const response = await api.get(`/avisos/${id}`);
      return response.data.aviso;
    } catch (error) {
      console.error(`Erro ao obter aviso ${id}:`, error);
      throw error;
    }
  },

  /**
   * Cria um novo aviso
   */
  criarAviso: async (aviso: Omit<Aviso, 'id' | 'data_criacao'>) => {
    try {
      const response = await api.post('/avisos', aviso);
      return response.data.aviso;
    } catch (error) {
      console.error('Erro ao criar aviso:', error);
      throw error;
    }
  },

  /**
   * Atualiza um aviso existente
   */
  atualizarAviso: async (id: string, aviso: Partial<Aviso>) => {
    try {
      const response = await api.put(`/avisos/${id}`, aviso);
      return response.data.aviso;
    } catch (error) {
      console.error(`Erro ao atualizar aviso ${id}:`, error);
      throw error;
    }
  },

  /**
   * Exclui um aviso
   */
  excluirAviso: async (id: string) => {
    try {
      await api.delete(`/avisos/${id}`);
      return true;
    } catch (error) {
      console.error(`Erro ao excluir aviso ${id}:`, error);
      throw error;
    }
  },

  /**
   * Marca um aviso como lido pelo usuário atual
   */
  marcarComoLido: async (avisoId: string) => {
    try {
      const response = await api.post(`/avisos/${avisoId}/leitura`);
      return response.data.leitura;
    } catch (error) {
      console.error(`Erro ao marcar aviso ${avisoId} como lido:`, error);
      throw error;
    }
  },

  /**
   * Fixa ou desfixa um aviso
   */
  alterarFixacao: async (avisoId: string, fixado: boolean) => {
    try {
      const response = await api.patch(`/avisos/${avisoId}/fixar`, { fixado });
      return response.data.aviso;
    } catch (error) {
      console.error(`Erro ao ${fixado ? 'fixar' : 'desafixar'} aviso ${avisoId}:`, error);
      throw error;
    }
  }
};


